import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0F0F0",
      d: "M13.999 25.666c6.443 0 11.666-5.223 11.666-11.666S20.442 2.333 14 2.333 2.332 7.556 2.332 14c0 6.443 5.223 11.666 11.667 11.666"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "14",
      cy: "14",
      r: "6",
      fill: "#BC002D"
    }, null, -1)
  ])))
}
export default { render: render }